import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

/**
 * Flag to include modified fields in modify payload
 */
@Injectable()
export class ModifiedFieldsArkikFeature implements IFlagFeature {
  name = Features.MODIFIED_FIELDS_ARKIK;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
